import { ControllerParams } from '@wix/yoshi-flow-editor';

import { EGroupPartition } from 'api/groups/types';
import type { IViewModel } from 'controller/types';

import { GroupsRequestSort, LayoutType } from 'settings/consts';
import { GroupsSelectorType } from 'settings/groups-list-widget';

import settingsParams from '../settingsParams';

type Resolvables = {
  persisted: boolean;
};

export function resolve(vm: IViewModel, params: ControllerParams) {
  const { settings, experiments } = params.flowAPI;

  return async function (resolvables?: Resolvables) {
    if (resolvables?.persisted) {
      return resolvables;
    }

    const limit = !experiments.enabled('specs.groups.CustomGroupListWidget')
      ? settings.get(settingsParams.numberGroups)
      : settings.get(settingsParams.groupListLayout) === LayoutType.grid
      ? 6
      : 5;

    await Promise.all([
      vm.application$.fetchUserProfile(),
      vm.groups$.query({
        limit,
        namespace: EGroupPartition.ALL,
        partition: EGroupPartition.ALL,
        sort: settings.get(settingsParams.sortBy) as GroupsRequestSort,
        groupIds: getGroupIdsToShow(),
      }),
    ]);

    return { persisted: true };
  };

  function getGroupIdsToShow() {
    if (!experiments.enabled('specs.groups.CustomGroupListWidget')) {
      return undefined;
    }
    switch (settings.get(settingsParams.groupsSelectorType)) {
      case GroupsSelectorType.ALL:
        return undefined;
      case GroupsSelectorType.CUSTOM:
        try {
          return JSON.parse(settings.get(settingsParams.groupIdsToShow));
        } catch (e: any) {
          return [];
        }
    }
  }
}
